import { Grid, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const CnjChart = ({ data, state }) => {
  const entes = ["Municipal", "Estadual", "Federal"];

  const [admChartData, setAdmChartData] = useState({
    series: [],
    options: {
      tooltip: { enabled: false },
      labels: entes,
      colors: ["#AADAFE", "#0281F1", "#012C6E"],
      plotOptions: {
        pie: {
          donut: {
            zoom: { enabled: false },
            tooltip: {
              enabled: false,
            },
            labels: {
              show: true,
              name: {
                show: true,
                fontFamily:
                  "'Hind Vadodara', sans-serif, 'Open Sans', Arial, Helvetica, Sans-Serif",
              },
              value: {
                fontFamily:
                  "'Hind Vadodara', sans-serif, 'Open Sans', Arial, Helvetica, Sans-Serif",
                fontSize: "14px",
                formatter: (v) =>
                  new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(v / 100),
              },
            },
          },
        },
      },
    },
  });

  useEffect(() => {
    let m = 0;
    let e = 0;
    let f = 0;
    let tribunais =
      state.tribunais.length == 0 ? Object.keys(data) : state.tribunais;

    tribunais.map((tribunal) => {
      entes.map((ente) => {
        const enteHash = data[tribunal][ente];

        if (enteHash != undefined) {
          const val = enteHash.valores;

          switch (ente) {
            case "Municipal":
              m += val;
              break;
            case "Estadual":
              e += val;
              break;
            case "Federal":
              f += val;
              break;
            default:
              break;
          }
        }
      });
    });

    setAdmChartData({
      ...admChartData,
      series: [m, e, f],
    });
  }, [state]);

  return (
    <Grid item sm={12} md={4}>
      <Paper>
        <Chart
          options={admChartData.options}
          series={admChartData.series}
          type="donut"
        />
      </Paper>
    </Grid>
  );
};

export default CnjChart;
